import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { ArticleList } from "@/components/site/ArticleItem";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [input, setInput] = useState(q);
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!q) return setResults(null);
    api.get("/articles", { params: { q } }).then((r) => setResults(r.data));
  }, [q]);

  const submit = (e) => {
    e.preventDefault();
    setParams(input.trim() ? { q: input.trim() } : {});
  };

  return (
    <div className="max-w-3xl pt-14" data-testid="search-page">
      <p className="meta">Search</p>
      <form onSubmit={submit} className="mt-5 flex items-center gap-3 border-b-2 border-[var(--ink)] pb-2" data-testid="search-form">
        <Search size={22} strokeWidth={1.5} className="text-[var(--ink-3)]" />
        <input
          autoFocus
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Search articles"
          className="flex-1 bg-transparent font-display text-3xl sm:text-4xl outline-none placeholder:text-[#BDBDBA]"
          data-testid="search-query-input"
        />
        <button type="submit" className="font-ui text-sm px-4 py-2 bg-[var(--ink)] text-white hover:bg-[var(--accent)] transition-colors" data-testid="search-submit-button">
          Search
        </button>
      </form>
      {results && (
        <>
          <p className="mt-6 meta" data-testid="search-results-count">
            {results.length} {results.length === 1 ? "result" : "results"} for “{q}”
          </p>
          <ArticleList articles={results} empty="No articles matched your search." testId="search-results" />
        </>
      )}
    </div>
  );
}
